import React, { useEffect } from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useDispatch, useSelector } from 'hooks/store';
import {
  cleanProductsAction,
  getProductListAction,
  remoteTotalSelector,
} from 'state/slices/products';
import { usePagination } from 'hooks/pagination';
import { PaginationData, Product } from 'constants/interface';

import {
  DetailPage,
  ListPage,
} from './pages';

const ViewProductsPage = (): JSX.Element => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const remoteTotal = useSelector(remoteTotalSelector);

  const remoteFetch = (
    paginationData: PaginationData,
  ) => {
    dispatch(getProductListAction(paginationData));
  };
  const pagination = usePagination<Omit<Product, 'variety'>>(
    remoteFetch,
    {
      filter: {
        isActive: true,
      },
    },
  );

  useEffect(() => {
    dispatch(cleanProductsAction());
  }, []);

  useEffect(() => {
    pagination.updateTotal(remoteTotal);
  }, [remoteTotal]);

  return (
    <Switch>
      <Route
        path={`${path}${ROUTES.dashboard.products.detail.root}`}
        render={() => <DetailPage onUpdateFinish={pagination.fetch} />}
      />
      <Route
        path={`${path}`}
        render={() => (
          <ListPage
            pageData={pagination.getInternal()}
            onTableChange={pagination.onTableChange}
            onSearch={pagination.onSearch}
            setFilter={pagination.setFilter}
          />
        )}
      />
    </Switch>
  );
};

export default ViewProductsPage;
